import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  HostListener
} from '@angular/core';
import { LMFormComponent } from '@form/lm-form.component';
import { LMKeyboardShortcutService, LMKeyType } from '@services/lm-keyboard-shortcut.service';

@Component({
  selector: 'lm-action-form',
  template: `
    <lm-form #lmactionform
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [initDataView]="dataView"
      [formOptions]="formOptions"
      [actionFormOptions]="actionFormOptions"
      [parentIsModal]="true"
      [ngStyle]="{'height': '100%'}"
      (titleChanged)="onTitleChanged($event)"
    ></lm-form>
  `
})
export class LMActionFormDialogComponent {

  @Input() formUrlInfo: LMFormUrlInfo;
  @Input() formSpec: LMFormSpec;
  @Input() dataView: LMDataView;
  @Input() formOptions: LMFormOptions;
  @Input() actionFormOptions: LMActionFormOptions;
  @Input() defaultButton: SohoModalButton;

  @Output() titleChanged = new EventEmitter<string>();

  @ViewChild(forwardRef(() => LMFormComponent), { static: true }) formComponent; // : LMFormComponent;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    //dont trigger default button by enter key when focused on a button, link, text area or a rich text field
    if (this.defaultButton) {
      const eventTarget: HTMLElement = event.target as HTMLElement;
      if (this.lmKeyboardShortcutService.onKeyDown(event) === LMKeyType.SAVE
        || ((event.code === 'Enter' || event.code === 'NumpadEnter')
        && eventTarget?.tagName !== 'BUTTON'
        && eventTarget?.tagName !== 'A'
        && eventTarget?.tagName !== 'TEXTAREA'
        && !eventTarget?.hasAttribute('soho-editor'))) {

        //need to trigger the blur event to trigger the field's change event
        eventTarget.blur();
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.defaultButton.click(null,null);
      }
    }
  }

  constructor(
    private changeDetectionRef: ChangeDetectorRef,
    private lmKeyboardShortcutService: LMKeyboardShortcutService,
  ) {}

  triggerDetectChanges() {
    this.changeDetectionRef.markForCheck();
  }

  onTitleChanged(newTitle: string) {
    this.titleChanged.emit(newTitle);
  }
}
